import { Alert, Container, Group, Text, ActionIcon } from "@mantine/core"
import { IconShieldOff } from "@tabler/icons-react"
import { IconX } from "@tabler/icons-react"
import { usePersistedBanner } from "@/hooks/usePersistedBanner"

const BANNER_ID = "transparency-warning-admin-manipulation"
const BANNER_VERSION = 2

export function TransparencyBanner() {
  const { dismissed, dismissBanner } = usePersistedBanner(BANNER_ID, BANNER_VERSION)

  if (dismissed) return null

  return (
    <Alert
      icon={<IconShieldOff size={20} />}
      title="TRANSPARENCY WARNING"
      color="red"
      variant="filled"
      radius={0}
      style={{
        borderBottom: "3px solid #dc2626",
        position: "relative",
        zIndex: 1000,
      }}
      withCloseButton={false}
    >
      <Container size="xl">
        <Group justify="space-between" align="center">
          <div style={{ flex: 1 }}>
            <Text size="sm" fw={600} style={{ marginBottom: "4px" }}>
              ⚠️ RECENT "RELEASES" ARE 97% PREVIOUSLY PUBLIC MATERIAL
            </Text>
            <Text size="xs" style={{ opacity: 0.9 }}>
              The current administration is actively blocking full transparency and manipulating releases. We demand
              COMPLETE, UNREDACTED files without political interference.
            </Text>
          </div>
          <ActionIcon variant="subtle" color="white" size="sm" onClick={dismissBanner} style={{ flexShrink: 0 }}>
            <IconX size={16} />
          </ActionIcon>
        </Group>
      </Container>
    </Alert>
  )
}
